import { TrackingDevice } from 'lib_ts/enums/training.enums';
import { IMachine } from 'lib_ts/interfaces/i-machine';

// whether to even show the option
export const isTrackingDeviceVisible = (
  device: TrackingDevice,
  machine: Partial<IMachine>
) => {
  switch (device) {
    case TrackingDevice.Hawkeye: {
      return !!machine.feature_flags?.hawkeye;
    }

    case TrackingDevice.TrackmanB1:
    case TrackingDevice.RapsodoV3PRO:
    case TrackingDevice.TrajektVision:
    default: {
      return true;
    }
  }
};

export const isTrackingDeviceEnabled = (
  device: TrackingDevice,
  machine: Partial<IMachine>
): boolean => {
  switch (device) {
    case TrackingDevice.TrajektVision: {
      return !!machine.enable_trajekt_vision;
    }

    default: {
      return true;
    }
  }
};

// whether to mark as beta
export const isTrackingDeviceBeta = (device: TrackingDevice) => {
  switch (device) {
    case TrackingDevice.Hawkeye:
    case TrackingDevice.TrackmanB1: {
      return true;
    }

    default: {
      return false;
    }
  }
};
